import { useMutation } from '@tanstack/react-query';
import Api from 'hooks/Api';
import { toastSuccess } from 'ui/partials/Toast';
import { useProvider } from 'utils/providers/Provider';
import { ApiError } from 'utils/types';

interface PAYLOAD {
  emailAddress: string;
}

export default function useForgotPassword() {
  const { state } = useProvider();
  const args = state;

  return useMutation<any, ApiError, PAYLOAD, any>({
    mutationFn: async (payload) => {
      const api = new Api(args);

      const data = await api.post({
        url: 'api/v1/auth/accounts/forgot-password',
        payload,
      });

      return data;
    },
    onSuccess: () => {
      toastSuccess('Successfully requested forgot password.');
    },
  });
}
